<div class="inner-page-bg-right">
  <header data-aos="zoom-in" class="aos-init aos-animate">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-12-custom">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'">
                <img src="./assets/images/logo-inner.png" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-5-custom">
          <div class="banner-left-text mt-5">
            <h1 data-aos="fade-up" class="aos-init aos-animate">Reset Password</h1>
          </div>
          <form [formGroup]="resetForm" class="form-container" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="row mb-2">
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="gap">
                  <mat-label>Password</mat-label>
                  <input matInput formControlName="password" placeholder="Password" [type]="hide ? 'password' : 'text'"
                    maxlength="10">
                  <button type="button" mat-icon-button matSuffix (click)="togglePasswordVisibility()"
                    [attr.aria-label]="hide ? 'Show password' : 'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> </button>
                  <mat-error *ngIf="submitted && f.password.errors?.required" class="invalid-feedback">
                    Password is required
                  </mat-error>
                  <button type="button" mat-icon-button matSuffix>
                    <mat-icon
                      matTooltip="1) Must contain Atleast 6 character 2) Must contain atleast 1 capital letter, 1 special character and 1 Numeric digit.">info</mat-icon>
                  </button>

                  <mat-error *ngIf="submitted && f.password.errors?.pattern" class="invalid-feedback">
                    Password must be at least 6 characters long, include 1 uppercase letter,1 special character, and 1
                    numeric
                    digit.
                  </mat-error>

                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field appearance="outline">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput [type]="confirmPasswordVisible ? 'text' : 'password'"
                    formControlName="confirmPassword" placeholder="Confirm Password" maxlength="10" />
                  <button mat-icon-button matSuffix (click)="toggleConfirmPasswordVisibility()" type="button"
                    [attr.aria-label]="'Toggle confirm password visibility'">
                    <mat-icon>{{ confirmPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
                  </button>

                  <mat-error *ngIf="submitted && f.confirmPassword.errors?.required" class="invalid-feedback">
                    Confirm Password is required.
                  </mat-error>
                  <mat-error *ngIf="f.confirmPassword.errors?.mustMatch">
                    Password and Confirm Password must match.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <button type="submit" mat-raised-button color="primary">Submit</button>
            <button type="button" class="mx-2" mat-raised-button (click)="onClickBack()">Back to Login</button>
          </form>
        </div>
        <div class="col-sm-7-custom aos-init aos-animate" data-aos="fade-up">
          <img src="./assets/images/signup-1.png" alt="" />
        </div>
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>